// @flow
import { RedesActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    red: {},
    listaRedes: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type RedesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { red?: {} | null, listaRedes?: [] | null, loading?: boolean, +value ?: boolean };

const Redes = (state: State = INIT_STATE, action: RedesAction): any => {
    // console.log(action);
    switch (action.type) {
        case RedesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case RedesActionTypes.GET_RED: {
                    return {
                        ...state,
                        red: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RedesActionTypes.LIST_REDES: {
                    return {
                        ...state,
                        listaRedes: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case RedesActionTypes.ADD_RED: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RedesActionTypes.UPDATE_RED: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RedesActionTypes.DELETE_RED: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RedesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case RedesActionTypes.GET_RED: {
                    return {
                        ...state,
                        error: action.payload.error,
                        red: {},
                        loading: false,
                    };
                }
                case RedesActionTypes.LIST_REDES: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaRedes: [],
                        loading: false,
                    };
                }
                case RedesActionTypes.ADD_RED: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RedesActionTypes.UPDATE_RED: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case RedesActionTypes.DELETE_RED: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case RedesActionTypes.GET_RED:
            return { ...state, error: false, loading: true };
        case RedesActionTypes.LIST_REDES:
            return { ...state, error: false, loading: true };
        case RedesActionTypes.ADD_RED:
            return { ...state, error: false, loadingForm: true };
        case RedesActionTypes.UPDATE_RED:
            return { ...state, error: false, loadingForm: true };
        case RedesActionTypes.DELETE_RED:
            return { ...state, error: false, loading: true };
        case RedesActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                red: {},
                listaRedes: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Redes;
